import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "document",
  "use": "document-usage",
  "viewBox": "0 0 36 37",
  "content": "<symbol viewBox=\"0 0 36 37\" xmlns=\"http://www.w3.org/2000/svg\" id=\"document\">\n<path d=\"M22.34 4.19922L32 13.8592V32.1992H4V4.19922H22.34ZM22.34 0.199219H4C1.8 0.199219 0 1.99922 0 4.19922V32.1992C0 34.3992 1.8 36.1992 4 36.1992H32C34.2 36.1992 36 34.3992 36 32.1992V13.8592C36 12.7992 35.58 11.7792 34.82 11.0392L25.16 1.37922C24.42 0.619219 23.4 0.199219 22.34 0.199219ZM8 24.1992H28V28.1992H8V24.1992ZM8 16.1992H28V20.1992H8V16.1992ZM8 8.19922H22V12.1992H8V8.19922Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol